import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface FooterLinkItem {
  /** Clave de traducción = el texto en español. */
  label: string;
  /** Ruta interna, o dirección completa (`mailto:`, `https:`, `tel:`) si `external`. */
  to: string;
  external?: boolean;
  /** Icono opcional a la izquierda — lo usan los datos de contacto. */
  icon?: ReactNode;
  /**
   * Texto a mostrar en vez de la traducción de `label`. Para un correo o un
   * teléfono, que NO se traducen: son datos, no frases.
   */
  literal?: string;
}

const CLASSES =
  "inline-flex items-center gap-2 text-[13px] text-ds-ink-3 transition-colors hover:text-ds-violet-pop";

/**
 * Un renglón del pie. Existe como componente porque el pie tiene diecisiete
 * y todos deben verse y comportarse igual.
 *
 * Los externos salen como `<a>` con `rel="noreferrer"`; los internos, como
 * `Link` del router. Mandar un `mailto:` por el router deja la página en
 * blanco, y navegar dentro del sitio con `<a>` recarga la aplicación entera.
 */
export function FooterLink({ label, to, external, icon, literal }: FooterLinkItem) {
  const { t } = useTranslation();
  const content = (
    <>
      {icon}
      {literal ?? t(label)}
    </>
  );

  if (external) {
    return (
      <a href={to} target="_blank" rel="noreferrer" className={CLASSES}>
        {content}
      </a>
    );
  }

  return (
    <Link to={to} className={CLASSES}>
      {content}
    </Link>
  );
}
